// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"21a8392c","115":"7f10cb3f","424":"032002e6","455":"935c77ce","546":"919f3032","776":"a734692b","869":"de766212","977":"bf899e87"}[chunkId] + ".chunk.js";
};